import useSWR, { unstable_serialize } from "swr";
import { messagingApi } from "./api";

export const useApi = ({
  url,
  params,
  lazy = false,
  method = "get",
  body,
  fetcher,
  fetchOptions,
}) => {
  const SWRKey = unstable_serialize([url, params, body]);
  const { data, error, isValidating, mutate } = useSWR(
    lazy ? null : SWRKey,
    fetcher
      ? () => fetcher()
      : () => messagingApi.request({ url, params, body, method }),
    fetchOptions
  );

  return {
    data,
    error,
    isValidating,
    mutate,
    isLoading: !lazy && !data && !error,
    isEmpty: !data || (Array.isArray(data) && data.length === 0),
  };
};
